import React from 'react';

import styles from './styles.module.scss';

export interface IAccessCodeProps {
  accessCode: Nullable<string>;
}

const AccessCode = ({ accessCode }: IAccessCodeProps) =>
  accessCode ? (
    <div className={styles.wrapper} data-testid="access-code">
      <div className={styles.instruction}>
        Your patient has not yet activated their prescription. Please have them
        download the app, and enter their email address and the prescription
        access code below:
      </div>
      <div className={styles['access-code']}>{accessCode}</div>
    </div>
  ) : null;

export default AccessCode;
